import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

type TrackEnterLiveAuctionPressedPayload = TrackingPayload & {
    catalogId: number;
};

const trackEnterLiveAuctionPressedAnalytics = (payload: TrackEnterLiveAuctionPressedPayload) => {
    track(TrackingEvents.Bidding.EnterLiveAuctionPressed, payload);
};

export const useTrackEnterLiveAuctionPressedAnalytics = (catalogId: number) => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(() => {
        trackEnterLiveAuctionPressedAnalytics({
            catalogId,
            pageName: getAmplitudePageNameFromPath(pathname),
            url,
        });
    }, [catalogId, pathname, url]);
};
